module.exports = __webpack_public_path__ + "media/images/folder-7213078fa2090f02bf9c6a5d1a8ff28891e9f899709b4cd0117e998d47bd7a69.svg";